export default {
  namespaced: true,
  state: {
    eventData: null, // Store the event
  },
  mutations: {
    SET_EVENT(state, event) {
      state.eventData = event; // Update event data
    },
    CLEAR_EVENT(state) {
      state.eventData = null; // Reset event data after handling
    },
  },
  actions: {
    emitEvent({ commit }, event) {
      commit("SET_EVENT", event);
    },
    clearEvent({ commit }) {
      commit("CLEAR_EVENT");
    },
  },
  getters: {
    requiresListReload: (state) => {
      const actionsRequireResetList = [
        "ban-hanh-success",
        "chuyen-xl-success",
        "tu-choi-success"
      ];
      return state.eventData && actionsRequireResetList.includes(state.eventData.action);
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/outgoing-docs.js